import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReportDownloadArgs, ReportGeneratedArgs } from '../../../../models/reports';
import moment from 'moment';
import { DownloadFormatOption } from '../report-buttons/report-buttons.component';

@Component({
  selector: 'lib-employee-rates',
  templateUrl: './employee-rates.component.html',
  styleUrls: ['./employee-rates.component.css'],
  standalone: false
})
export class EmployeeRatesComponent implements OnInit {
  @Input()
  public clientCode: string;
  @Output()
  public reportGenerated = new EventEmitter<ReportGeneratedArgs>();
  @Output()
  public reportDownloadClicked = new EventEmitter<ReportDownloadArgs>();
  public formats = [DownloadFormatOption.CSV()];
  private readonly ENDPOINT = 'EmployeeRates';
  constructor() {}

  ngOnInit(): void {}
  public generateReport() {
    this.reportGenerated.emit({ args: null, endpoint: this.ENDPOINT });
  }

  public downloadReport(format: string) {
    const now = moment().format('MMDDYYYY');
    this.reportDownloadClicked.emit({
      args: null,
      endpoint: this.ENDPOINT,
      filename: `Employee Rates_${this.clientCode}_${now}.${format}`,
      format
    });
  }
}
